import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import Integrations from "../../../integration/Integrations.jsx";
import { INTEGRATION_KEY } from "../../../state/integration/Constants";

class QuoteExportedToLightspeedRetailEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            quote: nextProps.quote || null,
            proposal: nextProps.proposal || null,
        })
    }


    render() {
        let lightspeedUrl = Integrations.getQuoteExternalUrl(this.state.object)
        return <div className={"row " + this.state.className}>
            <div className={'col-12'}>
                <p className={'mb-2'}>
                    <FormattedMessage
                        id="quote.analytics.events.exported.ls_retail.text"
                        defaultMessage="Proposal {identifier} has been exported to {integrationKey} as a quote"
                        values={{
                            integrationKey: Integrations.getIntegrationNameFromKey(INTEGRATION_KEY.LIGHTSPEED_RETAIL),
                            identifier: <strong>{this.state.quote.attributes.identifier}</strong>,
                        }}
                    />
                </p>
            </div>
            <div className={'col-12 d-flex align-items-center flex-wrap'}>
                <div className={'mr-3'}>
                    <a href={lightspeedUrl} target="_blank">
                        <img src="/images/lightspeed_retail_logo.png" width="150px" />
                    </a>
                </div>
                <div >
                    <p className={'mb-0'}>
                        <a href={lightspeedUrl} target={'_blank'} className={'btn btn-sm btn-outline-primary'}>
                            <FormattedMessage
                                id="quote.analytics.events.exported.ls_retail.open"
                                defaultMessage="Open quote in lightspeed"
                            />
                        </a>
                    </p>
                </div>
            </div>
        </div>
    }

}

export default QuoteExportedToLightspeedRetailEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/quote-exported-ls-retail.component.jsx